import { axiosPrivateSAI } from '../api/axiosSAI'
import { useEffect } from 'react'
import useRefreshData from './useRefreshData'
import useAuth from './useAuth'

const useAxiosPrivateSAI = () => {
  const refresh = useRefreshData()
  const { auth } = useAuth()

  useEffect(() => {
    const requestIntercept = axiosPrivateSAI.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${auth?.token}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const responseIntercept = axiosPrivateSAI.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true
          prevRequest.headers['Authorization'] = `Bearer ${auth.token}`
          return axiosPrivateSAI(prevRequest)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosPrivateSAI.interceptors.request.eject(requestIntercept)
      axiosPrivateSAI.interceptors.response.eject(responseIntercept)
    }
  }, [auth, refresh])

  return axiosPrivateSAI
}

export default useAxiosPrivateSAI
